import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import InputColorPicker from 'hb-react/shared/components/InputColorPicker';

const ColorPicker = ({
  title,
  name,
  label,
  id,
  disabled,
  defaultColor,
  disableAlpha,
  pickerPosition,
  onChange,
  wrapperProps,
}) => {
  const { setFieldValue } = useFormikContext();
  const htmlId = id || name;

  const handleChange = useCallback(
    ({ rgbNotation, hex }) => {
      setFieldValue(htmlId, rgbNotation ?? hex);
      if (onChange) {
        onChange(rgbNotation ?? hex);
      }
    },
    [htmlId, onChange, setFieldValue],
  );

  return (
    <Box {...wrapperProps}>
      <Field name={name} data-testid="formik-color-picker" disabled={disabled}>
        {({ field }) => (
          <InputColorPicker
            {...field}
            id={htmlId}
            name={name}
            title={title}
            label={label}
            disabled={disabled}
            defaultColor={defaultColor}
            disableAlpha={disableAlpha}
            color={field.value}
            pickerPosition={pickerPosition}
            onChange={handleChange}
            resetText={__('Reset color')}
          />
        )}
      </Field>
    </Box>
  );
};

ColorPicker.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  defaultColor: PropTypes.string,
  pickerPosition: PropTypes.string,
  onChange: PropTypes.func,
  wrapperProps: PropTypes.object,
};

ColorPicker.defaultProps = {
  disabled: false,
  wrapperProps: {},
};

export default ColorPicker;
